import _ from 'lodash';
import React, { useMemo } from 'react';
import { formatName, PropTypes } from '~/utils';
import { log } from '@swiper/core';
import app from '~/app';
import { Overlay } from './Overlay';
import { LiveSelector } from '~/components';
import { Container, Row, Col } from 'reactstrap';
import { useGlobalContext } from '~/context';

export function AddGuestOverlay( props ) {
  const { swipe, dispatch } = useGlobalContext();

  const opts = useMemo( () => {
    const handlePick = ( person ) => {
      if ( ! person ) return;
      log.debug( 'PICKED', person );
      return swipe.send( {
        event     : 'guest-in',
        guestId   : person.id,
      } ).then( () => dispatch.overlay.close() );
    };

    const handleAdd = ( name ) => {
      return app.service( 'guests' )
        .create( { membershipId : swipe.membershipId, name } )
        .then( guest => handlePick( guest ) );
    };
    return {
      renderItem  : formatName,
      query       : { membershipId : swipe.membership.id },
      onPick      : handlePick,
      onAdd       : handleAdd,
      placeholder : "Enter your guest's name",
      service     : 'guests',
      field       : 'name',
    };
  }, [ swipe, dispatch ] );

  return (
    <Overlay title="Add Guest" {...props}>
      <Container fluid>
        <Row>
          <Col md="6"><LiveSelector {...opts} /></Col>
          <Col md="6">
            <p>
              A <b>guest</b> is any guest that is not a member.  Signing
              in a guest <b>does</b> use a guest pass.
            </p>
            <p>
              If the guest you are signing in has been your guest before,
              they may appear in the list already, in that case you can
              just press the letter next to their name to sign them in.
            </p>
            <p>
              If you are signing in a guest who has been here before,
              maybe you should encourage them to join?
            </p>
          </Col>
        </Row>
      </Container>
    </Overlay>
  );
}
AddGuestOverlay.propTypes = {
  close   : PropTypes.func.isRequired,
};
